import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FootnoteTsAndCs extends Component {
	static propTypes = {
		intl: PropTypes.object.isRequired,
	};
	render() {
		const { intl } = this.props;
		return (
			<p className='dna-text-center dna-space-mtm' data-qa='footnote'>
				<small className='dna-text-xs-light'>
					{intl.formatMessage('content|login:register|TsAndCs-1')}&nbsp;
					<a data-qa='termsOfService' href='https://www.justgiving.com/info/terms-of-service/' target='_blank'>
						{intl.formatMessage('content|login:register|termsOfServiceLinkText')}
					</a>
					&nbsp;{intl.formatMessage('content|_defaults|and')}&nbsp;
					<a data-qa='privacyPolicy' href='https://www.justgiving.com/info/privacy/' target='_blank'>
						{intl.formatMessage('content|login:register|PrivacyPolicyLinkText')}
					</a>
				</small>
			</p>
		);
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/components/footnote/FootnoteTsAndCs.js